import omit from 'lodash/omit';

import { sortByOptions } from 'constants/sortByOptions';

import { UPDATESEARCH } from 'redux/modules/search/actions/types';
import { TRANSFORM_GRID_ITEMS } from 'redux/transforms';
import { COMPONENTS_AND_PRODUCTS_SCHEMA } from 'redux/schemas';

import { ensureSortByIsSet } from 'redux/modules/search/actions/helpers';

import { clearLocations } from 'redux/modules/content/actions/clear-locations';
import { clearSearch } from 'redux/modules/search/actions/clear-search';
import { fetchComponentsAndProducts } from 'redux/modules/search-and-browse/actions/fetch-components-and-products';

import { getCustomerId, getCustomerOrderId } from 'redux/modules/sessions/selectors';
import { getCustomerSlotDate } from 'redux/modules/customer-slot/selectors';

const cleanParams = params =>
  params.category ? omit(params, 'offerType') : omit(params, ['category', 'offerType']);

export const fetchOfferPage = ({ params, refinement }) => {
  const { offerType } = params;

  const cleanedParams = cleanParams(ensureSortByIsSet(params, sortByOptions.offers));

  return (dispatch, getState) => {
    const state = getState();
    const request = {
      api: offerType ? 'offersgroup' : 'offers',
      body: {
        customerId: getCustomerId(state),
        queryParams: {
          ...cleanedParams,
          orderId: getCustomerOrderId(state),
          adDate: getCustomerSlotDate(state),
          size: 48,
        },
      },
      method: 'put',
      name: 'OffersPage',
      properties: {},
      schema: COMPONENTS_AND_PRODUCTS_SCHEMA,
      transform: TRANSFORM_GRID_ITEMS,
    };

    if (offerType) {
      request.properties = { offerType };
    }

    dispatch(clearSearch(refinement));

    if (!refinement) {
      dispatch(clearLocations());
    }

    dispatch({
      type: UPDATESEARCH,
      params: {
        size: 48,
        ...cleanedParams,
      },
    });

    return dispatch(fetchComponentsAndProducts({ request, refinement }));
  };
};
